// Sessions
export const SESSION_GET_LOGIN = 'SESSIONS:GET_LOGIN'
export const SESSION_LOGIN = 'SESSIONS:LOGIN'
export const SESSION_LOGOUT = 'SESSIONS:LOGOUT'
export const SESSION_CHECK_AUTH = 'SESSIONS:CHECK_AUTH'
export const SESSION_UPDATE_PLAN = 'SESSIONS:UPDATE_PLAN'
